module.exports = __webpack_public_path__ + "static/media/unmute-icon.14ed042c.svg";